(function () {
    'use strict';
    var controllerId = 'eliminaFerie';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'richiesta', '$translate', '$filter', inoltraFerieFn]);

    function inoltraFerieFn($scope, $uibModalInstance, richiesta, $translate, $filter) {

        $scope.richiesta = richiesta;

        var msg = $translate.instant("Eliminare") + " " + $translate.instant("Richiesta") + ": ";
        var s = "";
        var dtInizio = $filter('date')(richiesta.DtInizio, 'dd/MM/yyyy');
        var dtFine = "";
        var oraInizio = "";
        var oraFine = "";

        if (richiesta.DtInizio != richiesta.DtFine)
            dtFine = " - " + $filter('date')(richiesta.DtFine, 'dd/MM/yyyy');

        if (richiesta.OraInizio)
            oraInizio = " " + richiesta.OraInizio;
        if (richiesta.OraFine)
            oraFine = " - " + richiesta.OraFine;

        s = dtInizio + oraInizio + dtFine + oraFine;

        msg += s + "?";
        $scope.Domanda = msg;

        $scope.cancel = function () {
            $uibModalInstance.close();
        };

        $scope.ok = function () {
            $uibModalInstance.close('ok');
        }
    }
})();
